import "./Loader.css";
const Loader = () => {
  return (
    <div className="spinner">
      <div className="ball"></div>
      <p>LOADING</p>
    </div>
  );
};

export default Loader;
